<script>
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  methods: {
    showDetails (type) {
      let typeEvent = type === 'CHECK-IN' ? 'CheckedIn' : 'CheckedOut'
      this.$emit('showDetails', typeEvent)
    }
  }
}
</script>

<template>
  <div class="card mini-stats-wid">
    <div class="card-body" style="padding: 1rem; min-height: 100px;">
      <div class="media">
        <div class="media-body text-left">
          <div style="display: flex; justify-content: space-between; align-items: flex-start;" class="mb-2">
            <h4>{{data.value}}<span style="color:#a1a1a1" v-show="data.hasTags && data.color !== 'dark'">/{{ data.hasTags }}</span></h4>
            <div v-if="data.title !== 'PARTICIPANTES CONFIRMADOS'" class="badge align-self-top p-1 font-size-11" :class="'bg-'+ data.color">{{ data.perc }}</div>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <p class="font-weight-medium mb-0 font-size-12" :class="'text-' + data.color">{{data.title}}</p>
            <button v-if="data.view" @click="showDetails(data.title)" class="font-weight-medium mb-0 font-size-12 btn btn-sm" :class="{ 'bg-green-dark text-white': data.color === 'green', 'bg-orange-dark text-white': data.color === 'orange'}">Visualizar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end card-body -->
  </div>
  <!-- end card -->
</template>
<style>
  .text-purple { color: #681AE8 !important; }
  .text-blue { color: #4D8FF2 !important; }
  .text-orange { color: #F26516 !important; }
  .text-green { color: #01B366 !important; }
  .text-white { color: #ffffff !important; }
  .text-red { color: #F51919 !important; }
  .bg-dark { background: #00000047 !important; color: #2b322e;}
  .bg-purple { background: #681ae847 !important; color: #2b322e;}
  .bg-blue { background: #4d8ff257 !important; color: #2b322e;}
  .bg-orange { background: #f265164f !important; color: #2b322e;}
  .bg-orange-dark { background: #f26716c5 !important; color: #2b322e;}
  .bg-green { background: #01b36669 !important; color: #2b322e;}
  .bg-green-dark { background: #34c38f !important; color: #2b322e;}
  .bg-red { background: #f5191966 !important; color: #2b322e;}
</style>
